import { render, staticRenderFns } from "./HorizontalSelectCategories.vue?vue&type=template&id=afbb5a74&scoped=true&"
import script from "./HorizontalSelectCategories.vue?vue&type=script&lang=js&"
export * from "./HorizontalSelectCategories.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalSelectCategories.vue?vue&type=style&index=0&id=afbb5a74&scoped=true&lang=scss&"
import style1 from "./HorizontalSelectCategories.vue?vue&type=style&index=1&id=afbb5a74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbb5a74",
  null
  
)

export default component.exports